/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { drawerWidth } from "@/themes/themeConstant";
import Image from "next/image";
import Link from "next/link";
import assest from "@/json/assest";
import { Button, styled } from "@mui/material";
import { useRouter } from "next/router";
import CloseIcon from "@mui/icons-material/Close";
import { setContext } from "@/api/axiosInstance";
import nookies from "nookies";
import { checkWindow } from "@/lib/functions/_helpers.lib";
import App from "next/app";
import type { AppContext, AppProps } from "next/app";
import { useAppSelector } from "@/hooks/useAppSelector";

function fixSSRLayout() {
  // suppress useLayoutEffect (and its warnings) when not running in a browser
  // hence when running in SSR mode
  if (!checkWindow()) {
    React.useLayoutEffect = () => {
      // console.log("layout effect")
    };
  }
}

//styled

const SideLogo = styled(Box)`
  .sideBarLogo {
    padding: 13px 0;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 5px;
    a {
      line-height: 0;
    }
    button {
      display: none;
      @media (max-width: 899px) {
        display: block;
      }
      svg {
        color: #d90429;
      }
    }
  }
  .MuiDivider-fullWidth {
    border-color: #ebeff2;
  }
`;

const SideBar = styled(Box)`
  .sidebarMenu {
    padding: 0px 20px;
    ul {
      padding: 0;
      li {
        margin: 0 0 16px;
        padding: 0;
        a {
          font-weight: 400;
          font-size: 16px;
          line-height: 26px;
          display: flex;
          align-items: center;
          color: #8d99ae;
          padding: 9px 16px;
          width:100%;
         
          img {
            margin: 0 12px 0 0;
          }
          &.active {
          background: #d90429;
          border-radius: 6px;
          color: #fff;
          width: 100%;
        
          a {
            color: #fff;
          }
          img {
            filter: brightness(0) invert(1);
          }
          }
          &:hover {
          background: #d90429;
          border-radius: 6px;
          color: #fff;
          width: 100%;
          
          a {
            color: #fff;
            img {
              filter: brightness(0) invert(1);
            }
          }
        }
        }
        /* &.active {
          background: #d90429;
          border-radius: 6px;
          a {
            color: #fff;
          }
          img {
            filter: brightness(0) invert(1);
          }
        } */
        /* &:hover {
          background: #d90429;
          border-radius: 6px;
          a {
            color: #fff;
            img {
              filter: brightness(0) invert(1);
            }
          }
        } */
      }
    }
  }
`;

interface SidebarInterFace {
  onClose: () => void;
  open: boolean;
}

export default function Sidebar(props: SidebarInterFace) {
  fixSSRLayout();
  const { open, onClose } = props;
  const router = useRouter();

  const [mappedGraphs, setMappedGraphs] = useState();
  //console.log(mappedGraphs, "mappedGraphs");

  const { userData } = useAppSelector((state) => state.userSlice);
  // console.log(userData, "userData");

  useEffect(() => {
    if (userData) {
      setMappedGraphs(
        userData?.accesses?.map((item) => {
          //console.log(item, "item");
          return item;
        })
      );
    }
  }, [userData]);

  //console.log(router.pathname, "userData");

  console.log(mappedGraphs, "mappedGraphs")

  const drawer = (
    <div>
      <SideLogo>
        <Box className="sideBarLogo">
          <Link href="/">
            <Image src={assest.logo} width={151} height={40} alt="" />
          </Link>
          <Button onClick={onClose}>
            <CloseIcon />
          </Button>
        </Box>
        <Divider />
      </SideLogo>
      <SideBar>
        <Box className="sidebarMenu">
          <List>
            <ListItem className={router.pathname === "/" ? "actives" : ""}>
              <Link href="/" className={router.pathname === "/" ? "active" : ""}>
                <Image
                  src={assest.dashboardIcon}
                  width={16}
                  height={15}
                  alt=""
                />
                <span>Dashboard</span>
              </Link>
            </ListItem>
          </List>
        </Box>
      </SideBar>
      <SideBar>
        <Box className="sidebarMenu">
          <List>
            {mappedGraphs?.length > 0
              ? mappedGraphs?.map((item) => {
                  return (
                    <>
                      <ListItem
                        style={{
                          display:
                            item === "client_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/manage-clients" || router.pathname === "/client-details/[slug]" ? "active" : ""
                        }
                      >
                        <Link href="/manage-clients" className={
                          router.pathname === "/manage-clients" || router.pathname === "/client-details/[slug]" ? "active" : ""
                        }>
                          <Image
                            src={assest.clientIcon}
                            width={20}
                            height={17}
                            alt=""
                          />
                          <span>Manage Clients</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "service_provider_management"
                              ? "block"
                              : "none",
                        }}
                        className={
                          router.pathname === "/manage-service-provider" || router.pathname === "/service-provider-details/[slug]" || router.pathname === "/edit-service/[id]" || router.pathname === "/edit-service-provider/[slug]" || router.pathname === "/add-service/[id]"
                            ? "active"
                            : ""
                        }
                      >
                        <Link href="/manage-service-provider" className={
                          router.pathname === "/manage-service-provider" || router.pathname === "/service-provider-details/[slug]" || router.pathname === "/edit-service/[id]" || router.pathname === "/edit-service-provider/[slug]" || router.pathname === "/add-service/[id]"
                            ? "active"
                            : ""
                        }>
                          <Image
                            src={assest.manageIcon}
                            width={17}
                            height={21}
                            alt=""
                          />
                          <span>Manage Providers</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "service_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/services" ? "active" : ""
                        }
                      >
                        <Link href="/services"  className={
                          router.pathname === "/services" ? "active" : ""
                        }>
                          <Image
                            src={assest.serviceIcon}
                            width={19}
                            height={20}
                            alt=""
                          />
                          <span>Services</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "staff_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/staff-management"|| router.pathname === "/staff-details/[slug]" || router.pathname === "/edit-staff/[id]" || router.pathname === "/create-staff-member" 
                            ? "active"
                            : ""
                         }
                      >
                        <Link href="/staff-management" className={
                          router.pathname === "/staff-management"|| router.pathname === "/staff-details/[slug]" || router.pathname === "/edit-staff/[id]" || router.pathname === "/create-staff-member"
                            ? "active"
                            : ""
                         }>
                          <Image
                            src={assest.staffIcon}
                            width={21}
                            height={24}
                            alt=""
                          />
                          <span>Office Management</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "projects_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/projects" || router.pathname === "/project-details/[slug]" ? "active" : ""
                        }
                      >
                        <Link href="/projects"  className={
                          router.pathname === "/projects" || router.pathname === "/project-details/[slug]" ? "active" : ""
                        }>
                          <Image
                            src={assest.projectIcon}
                            width={18}
                            height={19}
                            alt=""
                          />
                          <span>Projects</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "admin_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                        }
                      >
                        <Link href="/manage-admin" className={
                          router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                        }>
                          <Image
                            src={assest.adminIcon}
                            width={19}
                            height={24}
                            alt=""
                          />
                          <span>Staff Management</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "staff_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                        }
                      >
                        <Link href="/manage-admin" className={
                          router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                        }>
                          <Image
                            src={assest.adminIcon}
                            width={19}
                            height={24}
                            alt=""
                          />
                          <span>Staff Management</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "ads_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/ads-management" || router.pathname === "/create-new-ads" || router.pathname === "/ads-details/[id]" || router.pathname === "/edit-new-ads/[id]" ? "active" : ""
                        }
                      >
                        <Link href="/ads-management"  className={
                          router.pathname === "/ads-management" || router.pathname === "/create-new-ads" || router.pathname === "/ads-details/[id]" || router.pathname === "/edit-new-ads/[id]" ? "active" : ""
                        }>
                          <Image
                            src={assest.managementIcon}
                            width={23}
                            height={22}
                            alt=""
                          />
                          <span>Ads Management</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "transaction_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/transactions" || router.pathname === "/view-transaction" || router.pathname === "/manage-transaction" ? "active" : ""
                        }
                      >
                        <Link href="/transactions"  className={
                          router.pathname === "/transactions" || router.pathname === "/view-transaction" || router.pathname === "/manage-transaction" ? "active" : ""
                        }>
                          <Image
                            src={assest.transectionIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Manage Transactions</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        style={{
                          display:
                            item === "partners_and_sponsors_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/partnership" ? "active" : ""
                        }
                      >
                        <Link href="/partnership" className={
                          router.pathname === "/partnership" ? "active" : ""
                        }>
                          <Image
                            src={assest.partnerIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Partners & Sponsors</span>
                        </Link>
                      </ListItem>

                      {/* <ListItem
                        style={{
                          display:
                            item === "news_and_blog_management" ? "block" : "none",
                        }}
                        className={router.pathname === "/blog" || router.pathname === "/blog-details/[slug]" ? "active" : ""}
                      >
                        <Link href="/blog">
                          <Image
                            src={assest.newsIcon}
                            width={19}
                            height={20}
                            alt=""
                          />
                          <span>News & Blogs</span>
                        </Link>
                      </ListItem> */}

                      <ListItem
                        style={{
                          display:
                            item === "support_tickets_management" ? "block" : "none",
                        }}
                        className={
                          router.pathname === "/support-ticket" || router.pathname === "/support-ticket/support-category-ticket" || router.pathname === "/support-ticket/details/[id]"  || router.pathname === "/support-ticket/support-ticket-table"? "active" : ""
                        }
                      >
                        <Link href="/support-ticket" className={
                          router.pathname === "/support-ticket"  || router.pathname === "/support-ticket/support-category-ticket" || router.pathname === "/support-ticket/details/[id]"   || router.pathname === "/support-ticket/support-ticket-table" ? "active" : ""
                        }>
                          <Image
                            src={assest.supportIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Client Support</span>
                        </Link>
                      </ListItem>
                    </>
                  );
                })
              : userData?._id === "63da59271fbdbeb8661fb9b0" ? (
                  <>

                    <ListItem
                      className={
                        router.pathname === "/manage-clients" ||  router.pathname === "/client-details/[slug]" ? "active" : ""
                      }
                    >
                      {/* <Link href="/manage-clients/?value=0"> */}
                      <Link href="/manage-clients/" className={
                        router.pathname === "/manage-clients" ||  router.pathname === "/client-details/[slug]" ? "active" : ""
                      }>
                        <Image
                          src={assest.clientIcon}
                          width={20}
                          height={17}
                          alt=""
                        />
                        <span>Manage Clients</span>
                      </Link>
                    </ListItem>
    
                    <ListItem
                      className={
                        router.pathname === "/manage-service-provider" || router.pathname === "/service-provider-details/[slug]"
                         || router.pathname === "/add-service-provider" || router.pathname === "/edit-service/[id]"
                         || router.pathname === "/edit-service-provider/[slug]" || router.pathname === "/add-service/[id]"
                          ? "active"
                          : ""
                      }
                    >
                      <Link href="/manage-service-provider" className={
                        router.pathname === "/manage-service-provider" || router.pathname === "/service-provider-details/[slug]"
                        || router.pathname === "/add-service-provider" || router.pathname === "/edit-service/[id]"
                        || router.pathname === "/edit-service-provider/[slug]" || router.pathname === "/add-service/[id]"
                          ? "active"
                          : ""
                      }>
                        <Image
                          src={assest.manageIcon}
                          width={17}
                          height={21}
                          alt=""
                        />
                        <span>Manage Providers</span>
                      </Link>
                    </ListItem>
    
                    <ListItem
                      className={router.pathname === "/services" ? "active" : ""}
                    >
                      <Link href="/services" className={router.pathname === "/services" ? "active" : ""}>
                        <Image
                          src={assest.serviceIcon}
                          width={19}
                          height={20}
                          alt=""
                        />
                        <span>Services</span>
                      </Link>
                    </ListItem>
    
                    <ListItem
                      className={
                        router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                      }
                    >
                      <Link href="/manage-admin" className={
                        router.pathname === "/manage-admin"  || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                      }>
                        <Image
                          src={assest.adminIcon}
                          width={19}
                          height={24}
                          alt=""
                        />
                        <span>Staff Management</span>
                      </Link>
                    </ListItem>

                    <ListItem
                      className={
                        router.pathname === "/manage-admin" || router.pathname === "/staff-profile-details/[slug]" ? "active" : ""
                      }
                    >
                      <Link href="/bank-code" className={
                        router.pathname === "/bank-code" ? "active" : ""
                      }>
                        <Image
                          src={assest.addressIcon}
                          width={19}
                          height={24}
                          alt=""
                        />
                        <span>Bank Code</span>
                      </Link>
                    </ListItem>
    
                    <ListItem
                      className={
                        router.pathname === "/staff-management" || router.pathname === "/staff-details/[slug]"  || router.pathname === "/edit-staff/[id]" || router.pathname === "/create-staff-member" ? "active" : ""
                      }
                    >
                      <Link href="/staff-management" className={
                        router.pathname === "/staff-management" || router.pathname === "/staff-details/[slug]"  || router.pathname === "/edit-staff/[id]" || router.pathname === "/create-staff-member" ? "active" : ""
                      }>
                        <Image
                          src={assest.staffIcon}
                          width={21}
                          height={24}
                          alt=""
                        />
                        <span>Office Management</span>
                      </Link>
                    </ListItem>

                    <ListItem
                        className={
                          router.pathname === "/projects" || router.pathname === "/project-details/[slug]" ? "active" : ""
                        }
                      >
                        <Link href="/projects" className={
                          router.pathname === "/projects" || router.pathname === "/project-details/[slug]" ? "active" : ""
                        }>
                          <Image
                            src={assest.projectIcon}
                            width={18}
                            height={19}
                            alt=""
                          />
                          <span>Projects</span>
                        </Link>
                      </ListItem>

                      <ListItem
                    
                        className={
                          router.pathname === "/ads-management" || router.pathname === "/create-new-ads"  || router.pathname === "/ads-details/[id]" || router.pathname === "/edit-new-ads/[id]"? "active" : ""
                        }
                      >
                        <Link href="/ads-management" className={
                          router.pathname === "/ads-management" || router.pathname === "/create-new-ads"  || router.pathname === "/ads-details/[id]" || router.pathname === "/edit-new-ads/[id]"? "active" : ""
                        }>
                          <Image
                            src={assest.managementIcon}
                            width={23}
                            height={22}
                            alt=""
                          />
                          <span>Ads Management</span>
                        </Link>
                      </ListItem>

                      <ListItem

                        className={
                          router.pathname === "/transactions"  ||  router.pathname === "/view-transaction" || router.pathname === "/manage-transaction" ? "active" : ""
                        }
                      >
                        <Link href="/transactions" className={
                          router.pathname === "/transactions" || router.pathname === "/view-transaction" || router.pathname === "/manage-transaction" ? "active" : ""
                        }>
                          <Image
                            src={assest.transectionIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Manage Transactions</span>
                        </Link>
                      </ListItem>

                      <ListItem
                        className={
                          router.pathname === "/partnership" ? "active" : ""
                        }
                      >
                        <Link href="/partnership"  className={
                          router.pathname === "/partnership" ? "active" : ""
                        }>
                          <Image
                            src={assest.partnerIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Partners & Sponsors</span>
                        </Link>
                      </ListItem>

                      {/* <ListItem
                        className={router.pathname === "/blog" 
                        || router.pathname === "/blog-details/[slug]"
                        ? "active" : ""}
                      >
                        <Link href="/blog">
                          <Image
                            src={assest.newsIcon}
                            width={19}
                            height={20}
                            alt=""
                          />
                          <span>News & Blogs</span>
                        </Link>
                      </ListItem> */}

                      <ListItem
                        className={
                          router.pathname === "/support-ticket" ? "active" : ""
                        }
                      >
                        <Link href="/support-ticket"  className={
                          router.pathname === "/support-ticket" || router.pathname === "/support-ticket/support-category-ticket" ||router.pathname === "/support-ticket/details/[id]"  || router.pathname === "/support-ticket/support-ticket-table"? "active" : ""
                        }>
                          <Image
                            src={assest.supportIcon}
                            width={24}
                            height={24}
                            alt=""
                          />
                          <span>Client Support</span>
                        </Link>
                      </ListItem>


                  </>
                ) : (
                  ""
                )}
    
          </List>
        </Box>
      </SideBar>
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label="mailbox folders"
    >
      {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
      <Drawer
        variant="temporary"
        open={open}
        onClose={onClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}

/* Getting the current user from the server and passing it to the client. */
Sidebar.getInitialProps = async (context: AppContext) => {
  console.log("ggggg");
  setContext(context.ctx);
  const appProps = await App.getInitialProps(context);
  const cookies = nookies.get(context.ctx);
  console.log(cookies, "cookies");
  let hasToken = false;
  let user = null;

  if (cookies?.token?.length) {
    hasToken = true;
  }

  if (cookies?.user?.length) {
    user = JSON.parse(cookies?.user);
  }

  console.log(cookies?.userDetails, "headsssss");

  return { ...appProps, hasToken, user };
};
